var React = require('react');

function Birthday (props) {
    return React.createElement("svg",props);
}

Birthday.defaultProps = {"width":"0","height":"0","style":{"position":"absolute"}};

module.exports = Birthday;

Birthday.default = Birthday;
